import Vue from "vue";
import moment from 'moment';
import './iban.js';
import store from "../store";

Vue.filter('formatDate', function(value, format = 'DD MMM YYYY') {
  if (value) {
    const preferred_language = store.getters['main/getPreferredLanguage'] ?? 'en';
    return moment(String(value)).locale(preferred_language).format(format)
  }
});
// TODO check if the change here can be avoided
Vue.filter('formatDateWithTime', function(value, format = 'DD MMM YYYY HH:mm:ss') {
  if (value) {
    const preferred_language = store.getters['main/getPreferredLanguage'] ?? 'en';
    return moment(String(value)).locale(preferred_language).format(format)
  }
});

Vue.filter("formatNumberDecimal", function (value, rounding) {// load a format
    const preferred_language = store.getters['main/getPreferredLanguage'] ?? 'en';
    return Number(value).toLocaleString(preferred_language, {minimumFractionDigits: rounding, maximumFractionDigits: rounding});
});
Vue.filter("formatNumber", function (value) {// load a format
    const preferred_language = store.getters['main/getPreferredLanguage'] ?? 'en';
    return Number(value).toLocaleString(preferred_language, {minimumFractionDigits: 2, maximumFractionDigits: 2}); // displaying other groupings/separators is possible, look at the docs
});
Vue.filter("formatNumberInt", function (value) {// load a format
    const preferred_language = store.getters['main/getPreferredLanguage'] ?? 'en';
    return Number(value).toLocaleString(preferred_language, {minimumFractionDigits: 0, maximumFractionDigits: 0}); // displaying other groupings/separators is possible, look at the docs
});


Vue.filter("formatAddress", function (addressData) {
  if (addressData.name && addressData.name.length) {
    return addressData.name;
  }

  let formatted_address = '';

  if (addressData.street) {
    formatted_address += addressData.street + ' '
  }
  if (addressData.number) {
    formatted_address += addressData.number + ', '
  }
  if (addressData.postcode) {
    formatted_address += addressData.postcode + ', '
  }
  if (addressData.city) {
    formatted_address += addressData.city + ', '
  }
  if (addressData.country) {
    formatted_address += addressData.country_display
  }
  if (!formatted_address && addressData.latitude && addressData.longitude) {
    formatted_address += addressData.latitude + ', ' + addressData.longitude
  }

  return formatted_address
});

Vue.filter("amount2HourMin", function (value, h, m, toEmpty = false) {// load a format
  if(value === undefined||!value||value === 0){
    return (toEmpty) ? '' : '0h 0m'
  }
  var hours = Math.floor(value);
  var minutes = Math.round((value - hours)*60);
  return hours + h + " " + minutes + m;
});

Vue.filter('formatIBAN', (value) => {
  return window.IBAN.printFormat(value)
});
Vue.filter('isValidIBAN', (value) => {
  return window.IBAN.isValid(value)
});

Vue.filter('currency', (value, currency, decimals) => {
  const parsedValue = parseFloat(value).toFixed(decimals)
  let currencyValue = parsedValue + " " + currency
  if(!currency || currency === 'EUR') {
    currencyValue = "€" + parsedValue;
  }
  if (isNaN(parsedValue)) {
    currencyValue = ''
  }
  return currencyValue
})

Vue.filter('currencyString', (value, currency) => {
  const preferred_language = store.getters['main/getPreferredLanguage'] ?? 'en';
  const parsedValue = Number(value).toLocaleString(preferred_language, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  let currencyValue = parsedValue + " " + currency
  if(!currency || currency === 'EUR') {
    currencyValue = "€" + parsedValue;
  }

  return currencyValue
})